import { ContainerClient } from '@azure/storage-blob'
// import * as zip from "@zip.js/zip.js"

const reactAppUri = (process.env.NODE_ENV === 'development' ? process.env.REACT_APP_API_URI_DEV : process.env.REACT_APP_API_URI)

// Found this algorithm for making an auto-generated avatar background color based on the user's name
// MUI reference: https://mui.com/material-ui/react-avatar/#letter-avatars
const stringToColor = (string) => {
	if (string) {
		let hash = 0
		let i

		/* eslint-disable no-bitwise */
		for (i = 0; i < string.length; i += 1) {
			hash = string.charCodeAt(i) + ((hash << 5) - hash)
		}

		let color = '#';

		for (i = 0; i < 3; i += 1) {
			const value = (hash >> (i * 8)) & 0xff;
			color += `00${value.toString(16)}`.slice(-2)
		}
		/* eslint-enable no-bitwise */
		return color;
	} else {
		return '#467892'
	}
}

export const stringAvatar = (name) => {
	return {
		sx: {
			bgcolor: stringToColor(name),
		},
		children: (name.split(' ').length === 2 ? `${name.split(' ')[0][0]}${name.split(' ')[1][0]}` : 'P'),
	}
}

export const createContainerClientAndGetFiles = async (userId, setContainerClient, setFiles, cutOffDays = null) => {
	await getSasUri(userId)
		.then((res) => {
			const containerClient = new ContainerClient(res)
			setContainerClient(containerClient)
			return containerClient
		})
		.then((containerClient) => listFiles(containerClient, setFiles, cutOffDays))
}

export const getSasUri = async (userId) => {
	try {
		const sasUri = await fetch(
			`${reactAppUri}/getSasUri?containerName=${userId}`,
			{
				method: 'GET',
			}
		).then((res) => res.json())
		return sasUri
	} catch (error) {
		console.error(error)
	}
}

export const listFiles = async (containerClient, setFiles, cutOffDays) => {
	let files = []
	if (containerClient) {
		const cutOffDate = new Date()
		cutOffDate.setDate(cutOffDate.getDate() - cutOffDays) // Filters for last X days
		for await (const blob of containerClient.listBlobsByHierarchy('/')) {
			const { properties, etag, ...returnBlob} = {...blob, ...blob.properties, id: blob.properties.etag}
			if (cutOffDays !== null && returnBlob['lastModified'] >= cutOffDate) {
				files.push(returnBlob)
			} else if (cutOffDays === null){
				files.push(returnBlob)
			}
		}
		setFiles(files)
	}
}

export const uploadFiles = async (files, containerClient, setFiles, setLoading, cutOffDays = null) => {
	try {
		const promises = []
		setLoading(true)

		for (const file of files) {
			const blockBlobClient = containerClient.getBlockBlobClient(file.name)

			const temp = async () => {
				const res = await blockBlobClient.uploadData(file)
				const response = {
					...res,
					...blockBlobClient
				}
				return response
			}

			promises.push(temp())
		}
		const results = await Promise.all(promises)
		await listFiles(containerClient, setFiles, cutOffDays)
		setLoading(false)
		return results
	}
	catch (error) {
		console.error(error.message)
	}
}

export const sendNewUploadEmail = async (uploaderName, uploaderEmail, recipientName, recipientEmail, fileName, url, portalURI) => {
	const payload = {
		uploaderName,
		uploaderEmail,
		recipientName,
		recipientEmail,
		fileName,
		url,
		portalURI
	}
	const res = await fetch(`${reactAppUri}/newUploadEmail`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json'
		},
		body: JSON.stringify(payload)
	})
	if (res.ok) {
		res.json()
		return res
	} else {
		return false
	}
}

export const downloadBlob = (blob, name) => {
	// Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
	const blobUrl = URL.createObjectURL(blob)

	// Create a link element
	const link = document.createElement('a')

	// Set link's href to point to the Blob URL
	link.href = blobUrl
	link.download = name

	// Append link to the body
	document.body.appendChild(link)

	// Dispatch click event on the link
	// This is necessary as link.click() does not work on the latest firefox
	link.dispatchEvent(
		new MouseEvent('click', { 
		bubbles: true, 
		cancelable: true, 
		view: window 
		})
	)

	// Remove link from body
	document.body.removeChild(link)
}

export const downloadFiles = async (files, containerClient, setLoading) => {
	// TODO: Downloads, but should zip multiple files into one because it's not downloading more than about 10 files at once
	try {
		setLoading(true)
		const blobs = files.map(async (file) => {
			const blobClient = containerClient.getBlobClient(file.name)
			const downloadBlockBlobResponse = await blobClient.downloadToFile(file.name)
			const data = await downloadBlockBlobResponse.blobBody
			// var downloadedFile = new File([data], file.name, { type: file.contentType, });
			// return downloadedFile
			return { data, name: file.name }
		})
		if (blobs.length > 1) {
			Promise.all(blobs).then((res) => {
				console.log('multiple', res)
				res.map((blob) => downloadBlob(blob.data, blob.name))
				setLoading(false)
			})
		} else {
			Promise.resolve(blobs[0]).then((blob) => {
				console.log('single', blob)
				downloadBlob(blob.data, blob.name)
				setLoading(false)
			})
		}
	}
	catch (error) {
		setLoading(false)
		console.error(error.message)
	}
}

export const deleteFiles = async (files, containerClient, setFiles, setLoading, cutOffDays = null) => {
	try {
		const promises = []
		setLoading(true)

		for (const file of files) {
			const temp = async () => {
				const res = await containerClient.deleteBlob(file)
				return res
			}
			promises.push(temp())
		}
		await Promise.all(promises)
		await listFiles(containerClient, setFiles, cutOffDays)
		setLoading(false)
	}
	catch (error) {
		console.error(error.message)
	}
}
